import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  topUpSummary: {
    borderRadius: theme.spacing(7.5),
    border: '1px solid #B2B2C9',
    overflow: 'hidden',
  },
  topUpSummaryHeader: {
    backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(8.5, 35),
  },
  topUpSummaryTitle: {
    fontSize: theme.spacing(12),
    fontWeight: 600,
    lineHeight: '36px',
    color: theme.palette.common.white,
  },
  topUpSummaryMain: {
    padding: theme.spacing(17, 35, 20),

    '& p': {
      fontSize: theme.spacing(8),
      lineHeight: '15.6px',
      fontWeight: 600,
    },
  },
}));
